import { render, staticRenderFns } from "./BodyCompositionAnalysis.vue?vue&type=template&id=0f63fa31&scoped=true"
import script from "./BodyCompositionAnalysis.vue?vue&type=script&lang=js"
export * from "./BodyCompositionAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BodyCompositionAnalysis.vue?vue&type=style&index=0&id=0f63fa31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63fa31",
  null
  
)

export default component.exports